import React from "react";
import ScrollAnimation from 'react-animate-on-scroll';
import 'animate.css';

const EventPanelBase = ({ panelData }) => {
    if (!panelData) return null;
    
    const { panel_title, panel_list } = panelData;

    const oddBlockStyles = "h-full block sm:flex flex-wrap sm:flex-row md:items-center relative justify-between bg-[#001D53] text-white relative";
    const evenBlockStyles = "h-full block sm:flex flex-wrap sm:flex-row-reverse md:items-center relative justify-between bg-[#E7E9EC] text-[#001D53] relative";
    const bannerLeftStyle = "sm:absolute left-0 top-0 h-full w-full sm:w-1/2 z-10";
    const bannerRightStyle = "sm:absolute right-0 top-0 h-full w-full sm:w-1/2 z-10";

    return (
        <section className="mb-20">
            <div className="container mx-auto px-4">
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h6 className="bg-[#F3FF80] w-max px-3 py-1 mb-4 rounded-2xl m-auto">
                        Експертні діалоги
                    </h6>
                </ScrollAnimation>
                <ScrollAnimation animateIn="animate__fadeInUp">
                    <h2 className="text-4xl mb-9 uppercase text-center">{panel_title}</h2>
                </ScrollAnimation>
            </div>
            <div className="container mx-auto rounded-2xl overflow-hidden">
                <div className="grid grid-cols-1 gap-x-2">
                    {panel_list.map((panel, index) => (
                        <div
                            className={index % 2 === 0 ? "overflow-hidden " + oddBlockStyles : "overflow-hidden " + evenBlockStyles}>
                            <div
                                className={"text-4xl sm:text-8xl font-bold sm:order-2 relative z-20 items-center w-full sm:w-1/2 sm:h-full hidden sm:flex " + (index % 2 === 0 ? "text-[#f3ff80]/50 justify-start" : " text-[#001D53]/50 sm:justify-end")}>
                                <div
                                    className={"h-full w-max p-4 sm:p-9 flex items-center" + (index % 2 === 0 ? " bg-gradient-to-r from-[#001D53] to-[#001D53]/50 rounded-r-3xl" : " bg-gradient-to-l from-[#E7E9EC] to-[#E7E9EC]/50 rounded-l-3xl")}>{index + 1}</div>
                            </div>
                            <div
                                className={"sm:order-1 w-full sm:w-1/2 relative z-20 px-4 sm:px-9 p4 mb-4 sm:mb-0 pt-8 sm:py-16 " + (index % 2 === 0 ? "bg-[#001D53]" : " bg-[#E7E9EC] justify-end")}>
                                <ScrollAnimation animateIn="animate__fadeInUp">
                                    <h3 className="uppercase mb-4 text-xl sm:text-2xl max-w-3xl">
                                        <span className="sm:hidden">{index + 1}.</span> {panel.title}</h3>
                                </ScrollAnimation>
                                <ScrollAnimation animateIn="animate__fadeInUp">
                                    <p>{panel.text}</p>
                                </ScrollAnimation>
                            </div>
                            <div className={index % 2 === 0 ? bannerRightStyle : bannerLeftStyle}>
                                <ScrollAnimation key={index + 1}
                                                 animateIn={index % 2 === 0 ? "animate__fadeInLeft sm:h-full" : "animate__fadeInRight sm:h-full"}>
                                    <img src={panel.img} className="h-full w-full object-cover"/>
                                </ScrollAnimation>
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}

export default EventPanelBase;